import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 36px auto;
  grid-gap: ${({ open }) => open && "16px"};

  ${media.greaterThan("medium")`
    grid-gap: 16px;
    height: fit-content;
  `}
`;

export const AvatarBorder = styled.div`
  background-image: ${({ theme }) => theme.colors.gradient.gradientSpring};
  border-radius: 8px;
  height: 36px;
  width: 36px;
  padding: 2px;
`;

export const AvatarImage = styled.img`
  background-color: ${({ theme }) => theme.colors.neutral.gray8};
  border-radius: 8px;
  height: 100%;
  width: 100%;

  cursor: pointer;
`;

export const AvatarInitials = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.gray8};
  border-radius: 8px;
  height: 100%;
  width: 100%;
  color: ${({ theme }) => theme.colors.neutral.white};
  display: grid;
  place-content: center;
  cursor: pointer;
`;

export const Campaign = styled.div`
  display: none;

  ${media.greaterThan("medium")`
    display: grid;
    color:  ${({ theme }) => theme.colors.neutral.white};
  `}
`;

export const CampaignTitle = styled.h2`
  ${media.greaterThan("medium")`
    align-items: center;
    color: ${({ theme }) => theme.colors.neutral.white};
    ${({ theme }) => theme.font.body.sm};
    font-weight: ${({ theme }) => theme.font.weight.medium};
  `}
`;

export const CampaignText = styled.p`
  ${media.greaterThan("medium")`
    color: ${({ theme }) => theme.colors.neutral.gray7};
    ${({ theme }) => theme.font.body.xs};
  `}
`;
